import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { updateProjectDetail } from '@/service/projectService';
import { cloneDeep } from 'lodash';
import trI18n from '@/common/utils/trI18n';

/**
 * resetSetting
 * @param {*} argsCommon
 */
export const resetSetting = (argsCommon, projectList, projectId) => {
    let currentProject = projectList.find(project => project.id === projectId);
    if (Utils.isEmptyObject(currentProject) || !currentProject.iframeSetting) {
        argsCommon.setSettingIframe(argsCommon.initData);
        return;
    }
    let projectIframeSetting = Utils.convertJSONDataToObject(currentProject.iframeSetting);    
    argsCommon.setSettingIframe(projectIframeSetting);
    
    // argsCommon.setSettingIframe(argsCommon.initData);
    // argsCommon.setIframeLink('');

    // let currentProjectList = cloneDeep(projectList);
    // let currentProjectIndex = Utils.findIndexInArrayById(projectId, currentProjectList);
    // if (currentProjectIndex !== -1) {
    //     currentProjectList[currentProjectIndex].iframeSetting = JSON.stringify(argsCommon.initData);
    //     argsCommon.setProjectList(currentProjectList);
    // }

    let updateData = {
        iframeSetting: JSON.stringify(projectIframeSetting)
    };
    updateProjectDetail(argsCommon.API, projectId, updateData);
};

/**
 * generateNewIframeLink
 * @param {*} argsCommon
 * @returns
 */
 export const generateNewIframeLink = argsCommon => {
    if (!argsCommon.settingIframe || !argsCommon.projectId || !argsCommon.subDomain) return;
    argsCommon.setIsLoading(false);
    let iframeSrcData = {
        subDomain: argsCommon.subDomain,
        projectId: argsCommon.projectId
    };
    let encodeData = Utils.encodeDataByCrypto(
        iframeSrcData,
        Constant.SECRET_KEY_ENCRYPT_GENERATE_DATA
    );
    let iframeSrc = `${window.location.origin}${Constant.IFRAME_LOGIN_ROUTER}?backgroundColor=${encodeURIComponent(argsCommon.settingIframe.backgroundColor)}&info=${encodeData}`;

    let newIframeLink = generateIframeLink(iframeSrc, argsCommon.settingIframe);
    argsCommon.setIframeLink(newIframeLink);
    
    // Update projectList common state
    let currentProjectList = cloneDeep(argsCommon.projectList);
    let currentProjectIndex = Utils.findIndexInArrayById(argsCommon.projectId, currentProjectList);
    let iframeSettingClone = {...argsCommon.settingIframe};
    iframeSettingClone.customerInvitationSetting = Constant.CUSTOMER_INVITATION_SETTING.OFF;

    if (argsCommon.settingIframe.customerInvitationSetting) {
        iframeSettingClone.customerInvitationSetting = Constant.CUSTOMER_INVITATION_SETTING.ON;
    }
    if (currentProjectIndex !== -1) {
        currentProjectList[currentProjectIndex].iframeSetting = JSON.stringify(iframeSettingClone);
        argsCommon.setProjectList(currentProjectList);
    }
    let projectDetail = {...argsCommon.projectInuseDetail}
    projectDetail.iframeSetting = JSON.stringify(iframeSettingClone);
    argsCommon.setProjectInuseDetail(projectDetail);

    // Update setting
    let updateData = {
        iframeSetting: JSON.stringify(iframeSettingClone)
    };
    let update = updateProjectDetail(argsCommon.API, argsCommon.projectId, updateData);
    if (update) {
        argsCommon.setIsLoading(false)
    }
};

/**
 * generateIframeLink
 * @param {*} argsCommon
 */
export const generateIframeLink = (src, setting, settingIframePublickKnowledge = false) => {
    if (!src || Utils.isEmptyObject(setting)) return '';

    let iframeProperty = settingIframePublickKnowledge ? src : `src="${src}"`;

    if (setting.width) {
        iframeProperty = `${iframeProperty} width="${setting.width}${setting.widthHeightUnit}"`;
    }
    if (setting.height) {
        iframeProperty = `${iframeProperty} height="${setting.height}${setting.widthHeightUnit}"`;
    }
    if (setting.marginWidth) {
        iframeProperty = `${iframeProperty} marginwidth="${setting.marginWidth}"`;
    }
    if (setting.marginHeight) {
        iframeProperty = `${iframeProperty} marginheight="${setting.marginHeight}"`;
    }
    if (setting.borderSetting) {
        iframeProperty = `${iframeProperty} frameborder="1" style="border:${setting.borderSize} ${setting.borderStyle} ${setting.borderColor};"`;
    } else {
        iframeProperty = `${iframeProperty} frameborder="0"`;
    }

    let iframeLink = settingIframePublickKnowledge ? iframeProperty : `<iframe ${iframeProperty}></iframe>`;

    return iframeLink.toString();
};

/**
 * onChangeStyle
 * @param {*} e
 * @param {*} type
 * @param {*} argsCommon
 */
 export const onChangeStyle = (e, type, argsCommon) => {
    let newValue = e.target.value;
    let currentSettingIframe = cloneDeep(argsCommon.settingIframe);

    switch (type) {
        case 'style':
            currentSettingIframe.styleSheet = newValue;
            break;
        case 'header':
            currentSettingIframe.header = newValue;
            break;
        case 'footer':
            currentSettingIframe.footer = newValue;
            break;
        default:
            break;
    }

    argsCommon.setSettingIframe(currentSettingIframe);
};


/**
 * onChangeBorderSetting
 * @param {*} argsCommon
 */
export const onChangeBorderSetting = argsCommon => {
    let newBorderStatus = argsCommon.settingIframe.borderSetting ? false : true;
    let currentSettingIframe = cloneDeep(argsCommon.settingIframe);
    currentSettingIframe.borderSetting = newBorderStatus;
    argsCommon.setSettingIframe(currentSettingIframe);
};

/**
 * onChangeInputNumber
 * @param {*} e
 * @param {*} type
 * @param {*} argsCommon
 */
export const onChangeInputNumber = (e, type, argsCommon) => {
    let newValue = e.target.value;
    let currentSettingIframe = cloneDeep(argsCommon.settingIframe);

    switch (type) {
        case 'width':
            currentSettingIframe.width = newValue;
            break;
        case 'height':
            currentSettingIframe.height = newValue;
            break;
        case 'marginWidth':
            currentSettingIframe.marginWidth = newValue;
            break;
        case 'marginHeight':
            currentSettingIframe.marginHeight = newValue;
            break;

        default:
            break;
    }

    argsCommon.setSettingIframe(currentSettingIframe);
};

/**
 * onChangeSettingTypeSelect
 * @param {*} e
 * @param {*} argsCommon
 */
export const onChangeSettingTypeSelect = (e, argsCommon, type) => {
    let newSetting = e.target.value;
    let currentSettingIframe = cloneDeep(argsCommon.settingIframe);
    currentSettingIframe[type] = newSetting;
    argsCommon.setSettingIframe(currentSettingIframe);
};

/**
 * handleColorChange
 * @param {*} color
 * @param {*} argsCommon
 * @param {*} type
 */
export const handleColorChange = (color, argsCommon, type) => {
    let newColor = color.hex;
    let currentSettingIframe = cloneDeep(argsCommon.settingIframe);
    currentSettingIframe[type] = newColor;
    argsCommon.setSettingIframe(currentSettingIframe);
};

/**
 * onChangeSettingColor
 * @param {*} e
 * @param {*} type
 * @param {*} argsCommon
 */
export const onChangeSettingColor = (e, type, argsCommon) => {
    let newColor = e.target.value;
    let currentSettingIframe = cloneDeep(argsCommon.settingIframe);
    currentSettingIframe[type] = newColor;
    argsCommon.setSettingIframe(currentSettingIframe);
};

/**
 * isDisableSettingUserRegisterAccess
 * @param {*} argsCommon
 * @returns
 */
export const isDisableSettingUserRegisterAccess = argsCommon => {
    let isDisable = false;

    if (!argsCommon.settingIframe.public || !argsCommon.settingIframe.userNotRegisterAccess) {
        isDisable = true;
    }

    return isDisable;
};

/**
 * isDisableSettingUserNotRegisterAccess
 * @param {*} argsCommon
 * @returns
 */
export const isDisableSettingUserNotRegisterAccess = argsCommon => {
    let isDisable = false;

    if (!argsCommon.settingIframe.public || !argsCommon.settingIframe.userRegisterAccess) {
        isDisable = true;
    }

    return isDisable;
};

/**
 * onChangeSwitchGroupSetting
 * @param {*} argsCommon
 * @param {*} type
 */
export const onChangeSwitchGroupSetting = (argsCommon, type) => {
    // return if change input is disable
    switch (true) {
        case type === 'userNotRegisterAccess' && isDisableSettingUserNotRegisterAccess(argsCommon):
        case type === 'userRegisterAccess' && isDisableSettingUserRegisterAccess(argsCommon):
            return;
        default:
            break;
    }

    let currentSettingIframe = cloneDeep(argsCommon.settingIframe);
    currentSettingIframe[type] = currentSettingIframe[type] ? false : true;
    argsCommon.setSettingIframe(currentSettingIframe);
};

/**
 * Example function that does something with the parameters.
 * 
 * @param {*} e - The first parameter can be of any type.
 * @param {*} argsCommon - The second parameter can be of any type.
 * @param {Object} fieldData - An object containing field data.
 * @param {String} fieldData.type - The type of the field.
 * @param {Boolean} fieldData.required - Whether the field is required.
 * @returns {void}
 */
export const onChangeSubjectMailSetting = (e, argsCommon, fieldData = {} ) => {
           const newSubject = e?.target?.value;
           const fieldType = fieldData?.type;

           const hasError = handleFieldsError(argsCommon, fieldData, newSubject);
           
           if (!hasError) {
               argsCommon?.setErrMsg(preState => {
                   let newState = preState;
                   newState[fieldType] = ""
                   return newState;
               });
           }

           let currentSettingIframe = cloneDeep(argsCommon.settingIframe);
           currentSettingIframe[fieldType] = newSubject;
           argsCommon?.setSettingIframe(currentSettingIframe);
       };

/**
* 
* @param {*} argsCommon 
* @param {*} fieldData 
* @param {*} value 
* @returns 
*/
const handleFieldsError = (argsCommon, fieldData, value) => {
    let isError = false;
    const fieldType = fieldData?.type;
    const isRequired = fieldData?.required;

    // checking field required
    if (isRequired && !value) {
        isError = true;
        argsCommon?.setErrMsg(preState => {
            let newState = preState;
            newState[fieldType] = trI18n('COMM01MSG11');
            return newState;
        });
        return isError;
    }

    //checking field validate format
    switch (fieldType) {
        case Constant.IFRAME_SETTING.COMPLETED_SEND_TICKET_SUBJECT_MAIL:
            const isOverLength = Utils.isStringOverLength(value, 50);
            if (isOverLength) {
                isError = true;
                argsCommon?.setErrMsg(preState => {
                    let newState = preState;
                    newState[fieldType] = trI18n("OVER-50-CHARS");
                    return newState;
                });
            }
            break;
        default:
    }

    return isError;
};